<template>
  <div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
    <ul class="playlist" v-if="playlistMode == 1">
      <li v-for="item, index in playlist" class="playlist-item" :class="{ 'active': index == activeItemIndex }" @click="playItem(index)">
        <div class="playlist-item-thumbnail-wrapper">
          <span class="playlist-item-thumbnail-overlay">Läuft gerade</span>
          <img :src="item.image" alt="" class="playlist-item-thumbnail">
        </div>
        <div class="playlist-item-caption">
          <span class="playlist-item-title">{{item.title}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'
  import axios from 'axios'

  export default {

    name: 'VipoCollectionPlayer',

    mixins: [PlayerMixin],

    props: {
      collectionId: {
        required: true
      },
      videoId: {
        required: false
      },
      api: {
        required: false,
        default () {
          return 'http://www.rtl2.de/sites/default/modules/rtl2/mediathek/php/get_video_playlist_jw.php'
        }
      }
    },

    data () {
      return {
        vipoData: null,
        playlistMode: 0,
        playlist: [],
        activeItemIndex: 0,
      }
    },

    mounted () {

      if(this.$route.query.plm) {
        this.playlistMode = this.$route.query.plm
      }

      this.loadVipoData()
    },

    methods: {

      /**
       * Metadaten werden von VIPO API geladen
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      loadVipoData () {
        this.$l.log('loading videoCollection', this.collectionId)

        axios.get(this.$settings.vipo.vico, {
          params: {
            vico_id: this.collectionId
          }
        }).then((response) => {
          this.vipoData = response.data

          // OVERLAY:""
          // POSTROLL:"http://de-ipd.videoplaza.tv/proxy/distributor/v2?rt=vast_2.0&s=rtl2_rtl2/hilf_mir&tt=po&pf=ipd&t=j4%3D2,j5%3D0,j5%3D1,j5%3D2,j5%3D3,html5&rnd=__random-number__"
          // PREROLL:"http://de-ipd.videoplaza.tv/proxy/distributor/v2?rt=vast_2.0&s=rtl2_rtl2/hilf_mir&tt=p&pf=ipd&t=j4%3D2,j5%3D0,j5%3D1,j5%3D2,j5%3D3,html5&rnd=__random-number__"
          // VIAZ_Name:"rtl2.de"
          // beschreibung:"Jule steckt tief in der Patsche. Lars ist weg, sie hat eine Anzeige am Hals und ist völlig verzweifelt. Grade jetzt braucht sie ihre beste Freundin am dringendsten - und auf diese ist auch Verlass!"
          // captions:null
          // duration:"453"
          // image:"http://www.rtl2.de/vipo/img/51524_video-hilf-mir-jung-pleite-verzweifelt-folge-88-08.jpeg_vptn174x97.jpg"
          // link:"/sendung/hilf-mir-jung-pleite-verzweifelt/video/18970-best-of-brautalarm-folge-88/51524-jetzt-kommt-es-schlag-auf-schlag/"
          // poster:"http://www.rtl2.de/vipo/img/51524_video-hilf-mir-jung-pleite-verzweifelt-folge-88-08.jpeg_vptn720x405.jpg"
          // streamurl:"rtmp://cp108780.edgefcs.net/ondemand/flv_dach/vipo/hilf-mir-jung-pleite-verzweifelt/PR081226_8_01SU2HJ674T11SV2_8_10370814_10444103_16-9.mp4"
          // streamurl_hls:"http://trans_01_dach-vh.akamaihd.net/i/delivery/34/2a/342aef5c-09ef-4908-9ad7-702ae5874598/PR081226_8_01SU2HJ674T11SV2_8_10370814_10444103_16-9_,1350,2350,3850,250,650,65,1000,k.mp4.csmil/master.m3u8"
          // titel:"Jetzt kommt es Schlag auf Schlag!"
          // vico_id:"18970"
          // vico_mt_titel:"Best of �Brautalarm� (Folge 88)"
          // vifo_name:"Hilf mir! Jung, pleite, verzweifelt..."
          // vivi_id:"51524"
          // vpCategory:"rtl2_rtl2/hilf_mir"

          this.$manager.addItemData({
            source: 'vipo',
            id: this.vipoData[0].vivi_id,
            title: this.vipoData[0].title,
            description: this.vipoData[0].description,
            poster: this.vipoData[0].poster,
            format: this.vipoData[0].vifo_name,
            formatId: this.vipoData[0].video.formatId,
            duration: this.vipoData[0].duration,
            adZone: this.vipoData[0].vpCategory,
            collection: this.vipoData[0].vico_id,
            collectionName: this.vipoData[0].vico_mt_titel,
            permalink: this.vipoData[0].link,
          })

          this.setupCollection()

        }).catch((error) => {
          this.$warn('VIPO API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        })
      },

      setupCollection () {

        var playlist = []

        if(this.playlistMode == 1) {
            var collection = this.vipoData
            var playlist = []

            for(var videoNum in collection) {

                var video = collection[videoNum]

                // this.$l.log(video)

                playlist.push(video)
            }

            this.$manager.addOptions({
                visualplaylist: false
            })
        }
        else {
            playlist.push(this.vipoData[0])
        }

        this.$manager.addPlaylist(playlist)


        // this.$manager.addOptions({
        //   nextUpDisplay: true,
        //   related: {
        //       oncomplete: 'show',
        //       autoplaytime: 10
        //   }
        // })
        //
        // if(this.playlistMode == 1) {
        //   this.$manager.addOptions({
        //     visualplaylist: false
        //   })
        // }

        this.$manager.finalizeSetup()

      },

      getAdSchedule (video) {
        var adSchedule = {};

        if(!this.$settings.ads) {
            return adSchedule
        }

        // Preroll
        if(video.PREROLL && video.PREROLL != "") {
            adSchedule.preroll = {
                offset: "pre",
                tag: video.PREROLL
            };
        }

        // Midroll
        if(video.MIDROLL && video.MIDROLL != "") {
            adSchedule.midroll = {
                offset: "50%",
                tag: video.MIDROLL
            };
        }

        // Postroll
        if(video.POSTROLL && video.POSTROLL != "") {
            adSchedule.postroll = {
                offset: "post",
                tag: video.POSTROLL
            };
        }

        return adSchedule
      },

      playItem(index) {
        this.$l.log('playItem', index)
        this.$jwplayer.playlistItem(index)
      },

      playVideoId(videoId) {
          var collection = this.vipoData.collection
          for(var videoNum in collection) {

              var video = collection[videoNum]

              if( video.vivi_id == videoId ) {
                  this.playItem(videoNum)
                  return
              }

          }

          this.playItem(0)
      }


    },


    events: {
      jwPlaylist (evt) {
        this.playlist = evt.playlist

        if(this.videoId) {
            this.$l.log('playing playlist item with id',this.videoId)
            this.playVideoId(this.videoId)
        }
      },

      jwPlaylistItem (evt) {
        this.activeItemIndex = evt.index

        var video = this.vipoData.collection[evt.index]

        this.$manager.addItemData({
          source: 'vipo',
          id: video.vivi_id,
          title: video.titel,
          description: video.beschreibung,
          poster: video.poster,
          format: video.vifo_name,
          formatId: video.formatId,
          duration: video.duration,
          adZone: video.vpCategory,
          collection: video.vico_id,
          collectionName: video.vico_mt_titel,
          permalink: video.link,
        })
      },

        jwBeforeComplete (evt) {
            this.$l.log('beforecomplete')
            this.$jwplayer.pause()
            // this.$l.log('jwplayer',this.$jwplayer)
        }

    },



  }
</script>

<style lang="scss">

.playlist {
  background: #000;
  color: #eee;
  margin: 0;
  padding: 10px;

  .playlist-item {
    cursor: pointer;

    background: #222;

    list-style-type: none;
    margin: 1%;
    padding: 3px;
    max-width: 23%;
    display: inline-block;
    box-sizing: border-box;

    &.active {
      .playlist-item-thumbnail {
        border: 5px solid #fe0;
      }

      .playlist-item-thumbnail-overlay {
        display: block;
      }
    }

    &:hover {
      .playlist-item-caption {
        text-decoration: underline;
      }
    }
  }

  .playlist-item-thumbnail-wrapper {
    position: relative;
    text-align: center;
  }

  .playlist-item-thumbnail {
    box-sizing: border-box;
    max-width: 100%;
  }

  .playlist-item-thumbnail-overlay {
    display: none;
    position: absolute;
    top: 45%;
    width: 100%;
    text-transform: uppercase;
    font-style: italic;
  }

  .playlist-item-caption {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 6px 0px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/VipoCollection.vue